import React from "react";
import { getFileIcon } from "../../utils/fileIcon";

const ChatFiles = ({ files, showPreview}) => {

  return (
    <div className="message__files">
      <hr className='custom-hr' />
        <span className="text-muted title-attachments">Attachment(s):</span>
      {files.map((file) => {
        return (
          <div key={file.id} className="message__file">
           
              <div className="file-bubble document-file" style={{ cursor: "pointer" }} onClick={() => showPreview(file)}>
                <img
                  src={getFileIcon(file.file_name)}
                  alt={file.file_name}
                  className="file-icon"
                />
                <span className="file-name">
                  {file.file_name}
                </span>
              </div>
          </div>
        );
      })}
    </div>
  );
};

export default ChatFiles;
